import { Promise } from 'rsvp';
import Service, { inject as service } from '@ember/service';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';
import { APP_CACHE__COMMON_TIMEOUTS } from "../app-cache";
import { ERROR_MESSAGES } from "../../constants/error-messages";

/**
 * Service for service related API calls.
 */
export default Service.extend({
  api: service(),
  appCache: service(),
  shData: service(),

  /**
   * Load all the services from the server.
   *
   * @param {Array<String>=} opt_includes
   * @return {Ember.RSVP.Promise|*}
   */
  loadAllServices(opt_includes = []) {
    let servicesFromCache = this.appCache.getCachedModelArrayForRequest(this, 'loadAllServices', arguments);
    if (servicesFromCache) {
      return Promise.resolve(servicesFromCache);
    }

    let options = {};
    this.shData.addIncludesToOptions(options, opt_includes);

    return new Promise((resolve, reject) => {
      this.get('api').request(`services/`, options).then(response => {
        this.shData.pushResponseToStore(response);

        let services = this.shData.getModelArrayFromResponse(response, 'service');

        this.appCache.setCachedModelArrayForRequest(
          this,
          'loadAllServices',
          arguments,
          services,
          APP_CACHE__COMMON_TIMEOUTS.ONE_HOUR_SECONDS);

        resolve(services);
      }).catch(e => {
        handleErrorResponseWithModal(
          this,
          e,
          ERROR_MESSAGES.GENERIC_ERROR_MESSAGE,
          'loadAllServices -- error loading services',
        );

        reject(e);
      });
    });
  },

  recordSearchInput(service, searchInput) {
    const options = {
      params: {
        input: searchInput,
      }
    }

    return this.api.post(`services/${service.id}/search`, options);
  }
});
